import i18n, { type Resource } from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import otaClient from '@crowdin/ota-client';

import defaultStrings from './locales/en.json';

export const defaultLocale = 'en';
export const supportedLocales = [defaultLocale, 'de'] as const;
export type SupportedLocales = (typeof supportedLocales)[number];

const getResources = async () => {
  const crowdinOtaHash = import.meta.env.VITE_CROWDIN_DISTRIBUTION_HASH;
  const crowdinOtaClient = new otaClient(crowdinOtaHash);
  const crowdinStrings = await crowdinOtaClient.getStrings();

  const resources: Resource = {
    en: {
      translation: defaultStrings,
    },
  };
  supportedLocales
    .filter((locale) => locale !== defaultLocale)
    .forEach((locale) => {
      resources[locale] = {
        translation: crowdinStrings[locale],
      };
    });

  return resources;
};

export const initI18n = async () => {
  const resources = await getResources();
  await i18n
    .use(LanguageDetector)
    .use(initReactI18next)
    .init({
      resources,
      supportedLngs: supportedLocales,
      fallbackLng: defaultLocale,
      interpolation: {
        escapeValue: false,
      },
      detection: {
        order: ['localStorage'],
        caches: ['localStorage'],
      },
    });
};

export default i18n;
